var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm._t("bodyTop"),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("emailModal.subject")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.subject,
                        expression: "subject"
                      }
                    ],
                    staticClass: "form-control",
                    domProps: { value: _vm.subject },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.subject = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("Quill", {
                  model: {
                    value: _vm.html,
                    callback: function($$v) {
                      _vm.html = $$v
                    },
                    expression: "html"
                  }
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.dismiss()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("btnCancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("send", {
                        subject: _vm.subject,
                        context: _vm.context,
                        html: _vm.html
                      })
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.sendButtonText) + "\n        "
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }